var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPaMessageTemplates = function SvgPaMessageTemplates(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 38.4,
    height: 38.4,
    fill: "#FFF",
    rx: 6.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#35333C",
    fillRule: "nonzero",
    stroke: "#35333C",
    strokeLinejoin: "bevel",
    strokeWidth: 0.5,
    d: "M27.6 8c1.54 0 2.8 1.26 2.8 2.8h0v16.8c0 1.54-1.26 2.8-2.8 2.8h0-16.8c-1.54 0-2.8-1.26-2.8-2.8h0V10.8C8 9.26 9.26 8 10.8 8h0zm0 1.12H10.8c-.945 0-1.68.735-1.68 1.68h0v16.8c0 .945.735 1.68 1.68 1.68h16.8c.945 0 1.68-.735 1.68-1.68h0V10.8c0-.945-.735-1.68-1.68-1.68h0zM25.85 24.8c.21 0 .35.14.35.35h0v.7c0 .21-.14.35-.35.35h0-13.3c-.21 0-.35-.14-.35-.35h0v-.7c0-.21.14-.35.35-.35h0zm0-4.2c.21 0 .35.14.35.35h0v.7c0 .21-.14.35-.35.35h0-13.3c-.21 0-.35-.14-.35-.35h0v-.7c0-.21.14-.35.35-.35h0zm-8.75-8.4c.385 0 .7.315.7.7h0v4.2c0 .385-.315.7-.7.7h0-4.2c-.385 0-.7-.315-.7-.7h0v-4.2c0-.385.315-.7.7-.7h0zm8.75 4.2c.21 0 .35.14.35.35h0v.7c0 .21-.14.35-.35.35h0-4.9c-.21 0-.35-.14-.35-.35h0v-.7c0-.21.14-.35.35-.35h0zm-9.45-2.8h-2.8v2.8h2.8v-2.8zm9.45-1.4c.21 0 .35.14.35.35h0v.7c0 .21-.14.35-.35.35h0-4.9c-.21 0-.35-.14-.35-.35h0v-.7c0-.21.14-.35.35-.35h0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPaMessageTemplates);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pa-message-templates.fc2d85cf07ba0f11d2ecb8956bf38649.svg";